export const productFallbackImage =
    'https://s3.eu-west-1.amazonaws.com/public.ourliving.se/ourliving/product-fallback-image-white.jpg';
